import React, { useState } from 'react';
import { View, TextInput, Text, Pressable } from 'react-native';
import { StyleSheet, useUnistyles } from 'react-native-unistyles';
import Unicon from '@/components/General/Unicon';

export default function NoteInput({ value = '', onChange, placeholder = 'Add a note (optional)', testID = 'note-input', collapsible = false, isNotOnSurface = false, appearance = null }) {
    const [expanded, setExpanded] = useState(false);
    const { theme: { colors } } = useUnistyles();

    if (collapsible && !expanded && !value) {
        return (
            <Pressable
                testID={`${testID}-add`}
                onPress={() => setExpanded(true)}
                style={styles.addRow}
            >
                <Unicon name="create-outline" size={18} color={appearance?.textColor ? `${appearance.textColor}B3` : null} colorVariant="textSecondary" />
                <Text style={[styles.addText, appearance?.textColor && { color: `${appearance.textColor}B3` }]}>Add a note</Text>
                <Unicon name="chevron-down" size={16} color={appearance?.textColor ? `${appearance.textColor}80` : null} colorVariant="textTertiary" />
            </Pressable>
        );
    }

    return (
        <View style={styles.container} testID={testID}>
            <Text style={[styles.title, appearance?.textColor && { color: appearance.textColor }]}>Note</Text>
            <TextInput
                testID={`${testID}-field`}
                style={[styles.input(isNotOnSurface), appearance?.inputColor && { backgroundColor: appearance.inputColor }, appearance?.textColor && { color: appearance.textColor }]}
                value={value}
                onChangeText={onChange}
                placeholder={placeholder}
                placeholderTextColor={appearance?.textColor ? `${appearance.textColor}B3` : colors.textSecondary}
                multiline
                numberOfLines={3}
                textAlignVertical="top"
            />
        </View>
    );
}

const styles = StyleSheet.create(({ colors: themeColors, fonts, shadows, spacing, roundness, typography }, rt) => ({
    container: {
        gap: spacing.sm,
    },
    addRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: spacing.sm,
        paddingVertical: spacing.xs,
    },
    addText: {
        flex: 1,
        fontSize: typography.body,
        fontFamily: fonts.body,
        color: themeColors.textSecondary,
    },
    title: {
        fontSize: typography.h3,
        fontFamily: fonts.heading,
        color: themeColors.text,
    },
    input: (isNotOnSurface) => ({
        minHeight: Math.max(80, Math.ceil(80 * rt.fontScale)),
        borderRadius: roundness.md,
        backgroundColor: isNotOnSurface ? themeColors.surface : themeColors.inputBackground,
        boxShadow: isNotOnSurface ? shadows.card : shadows.none,
        color: themeColors.text,
        fontFamily: fonts.body,
        fontSize: typography.body,
        padding: spacing.md,
        textAlignVertical: 'top',
        outlineStyle: 'none',
        _web: {
            transition: "all 0.15s ease",
            _focus: {
                boxShadow: shadows.input,
            },
            _hover: {
                backgroundColor: themeColors.hover,
            },
        },
    }),
}));
